import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Preset } from '../../../components/Button';
import { TextButton } from '../../../components/TextButton';
import { colorBgWithStateAutoFont } from 'mt-react-theme-manager';

import './styles.scss';

interface Props {
  onSubmit: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onCancel: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default function FastOnboardFormFooter({
  onSubmit,
  onCancel
}: Props): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="sso-onboard-form-footer">
      <div className="footer-content">
        <TextButton
          big
          className={`${colorBgWithStateAutoFont('secondary')} onboard-cancelled-button`}
          preset={Preset.None}
          text={t('SSOOnboardForm.footer.jp.cancelButton')}
          type="button"
          onPress={onCancel}
        />
        <TextButton
          big
          className={`${colorBgWithStateAutoFont('primary')} onboard-agreed-button`}
          preset={Preset.None}
          text={t('SSOOnboardForm.footer.jp.submitButton')}
          type="submit"
          onPress={onSubmit}
        />
      </div>
    </div>
  );
}
